import { Component, Inject } from '@angular/core';
import { DeleteElementGQL, ElementDetailsFragment, ElementDetailsGQL } from "@/core/graphql/graphql";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import { ConfirmDialogComponent } from "@/shared/components/confirm-dialog/confirm-dialog.component";
import { ConfirmDialogModel } from "@/shared/components/confirm-dialog/confirm-dialog.model";
import { filter, first, switchMap } from "rxjs/operators";
import { ElementDialog } from "@/modules/elements/components/element-details-modal/element-dialog.model";
import { ToastService, ToastType } from "@/core/services/toast.service";

@Component({
  selector: 'cosmos-element-modal-details',
  templateUrl: './element-details-modal.component.html',
  styleUrls: ['./element-details-modal.component.scss'],
})
export class ElementDetailsModalComponent {
  public _element: ElementDetailsFragment;
  public loading: boolean = false;

  public constructor(
    private readonly _modalRef: MatDialogRef<ElementDetailsModalComponent>,
    private readonly _elementDetailsGql: ElementDetailsGQL,
    private readonly _dialog: CosmosDialogService,
    private readonly _deleteElementGQL: DeleteElementGQL,
    private readonly _toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) private readonly data: { elementId: number },
  ) {
    this.loading = true;
    this._elementDetailsGql.fetch({ id: this.data.elementId })
      .toPromise()
      .then((next) => {
        this._element = next.data.element;
        this.loading = false;
      });
  }

  public closeDetails(data?: ElementDialog): void {
    this._modalRef.close(data);
  }

  public deleteElement(): void {
    const data: ElementDialog = {
      refreshData: true,
    };

    const dialogRef = this._dialog.open<ConfirmDialogComponent, ConfirmDialogModel>(ConfirmDialogComponent, {
      data: {
        dialogMessage: 'Do you want to delete this element?',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
      },
      style: CosmosDialogStyle.Gray,
    });
    dialogRef.afterClosed().pipe(
      first(),
      filter(data => !!data),
      switchMap(() => {
        return this._deleteElementGQL.mutate({
          ids: [this._element.id],
        });
      })
    ).subscribe((_) => {
      this.closeDetails(data);
      this._toastService.raiseMessage("Element has been deleted", ToastType.Warning );
    });
  }
}
